const defaultState = {
    
};

const limitAndPaymentInformationReducer = (state = {...defaultState}, action) => {
  switch (action.type) {
    case "RESET_LIMIT_AND_PAYMENT_INFO":
      return {
        ...defaultState
      }
    case "UPDATE_LIMIT_AND_PAYMENT_INFO":
      return {
        ...state,
        ...action.payload
      };
    case "UPDATE_INSURANCE_SELECTION":
      return {
        ...state,
        interestList: state.interestList.map((val) => {
          if(val.id === action.payload.id){
            return {
              ...val,
              insuranceSelection:action.payload.insuranceSelection
            }
          } else {
            return {...val}
          }
        })
      }
    default:
      return { ...state };
  }
};

export default limitAndPaymentInformationReducer;
